import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Content, MessageCard, i18n, tokens, ChangeRequestForm, Button } from '@simplybenefits/sb-ui-library';
import { getChangeRequestDataReadOnly, approveChangeRequest, declineChangeRequest } from '../../actions/changeRequests.js';
import { listFiles, createFolder, uploadFile, downloadFile, removeFile } from '../../actions/files.js';

/**
 *
 * @param dispatch
 * @param match
 * @param loader
 * @returns {JSX.Element}
 * @constructor
 */
const ChangeRequestDetailsView = ({ dispatch, match, loader }) => {
    const [ changesRequestData, setChangeRequestData ] = useState(null);
    const [ changeRequestID, setChangeRequestID ] = useState(null);
    const [ locale, setLocale ] = useState(i18n.locale);

    useEffect(() => {

        /**
         *
         * @returns {Promise<void>}
         */
        const fetchData = async () => {
            const id = match.params?.id;
            const reviewerID = match.params?.reviewerID;
            const changeRequest = await dispatch(getChangeRequestDataReadOnly(match.params?.changeRequestID, id, reviewerID));

            if (changeRequest) {
                setChangeRequestID(match.params?.changeRequestID);
                setChangeRequestData(changeRequest);
            }
        };

        fetchData();
    }, []);

    /**
     * 
     */
    const _toggleUserLocale = () => {
        i18n.toggleLocale();
        setLocale(i18n.locale);
    };

    /**
     * 
     * @param {*} submitData Data returned from the change request form
     * @param {*} submitType Approve or Decline
     * @returns 
     */
    const submit = async (submitData, submitType) => {
        let successData = null;
    
        if (submitType === 'Approve') {
            successData = await dispatch(approveChangeRequest(changeRequestID, submitData));
        } else if (submitType === 'Decline') {
            successData = await dispatch(declineChangeRequest(changeRequestID, submitData));
        }

        if (successData.updatedChangeRequestFile) {
            setChangeRequestData((prevState) => ({ 
                ...prevState,
                ...successData.updatedChangeRequestFile
            }));

            window.scrollTo({ top: 0, behavior: 'smooth' });
            return true;
        }

        return false;
    };

    return (
        <Content>
            <Button 
                onClick={() => _toggleUserLocale() }
                customStyle={{ margin: '10px 0 -10px 0' }}
            >
                { locale === 'en' ? 'Français' : 'English' }
            </Button>

            {changesRequestData && (
                <MessageCard
                    title={i18n.t(changesRequestData?.status?.toLowerCase() === 'pending member review'
                        ? tokens.labels.changeRequests.reviewChangeRequest
                        : tokens.labels.employees.pending)}
                    subtitle={i18n.t(changesRequestData?.status?.toLowerCase() === 'pending member review'
                        ? tokens.labels.changeRequests.reviewChangeRequestBodyMember
                        : tokens.labels.changeRequests.changeRequestPendingReview)}
                />
            )}

            {
                changesRequestData ?
                    <ChangeRequestForm
                        accessType={'member'}
                        data={ changesRequestData }
                        type="users"
                        id={ changesRequestData.userID }
                        dispatch={ dispatch }
                        loader={ loader }
                        listFiles={ listFiles }
                        createFolder={ createFolder }
                        uploadFile={ uploadFile }
                        downloadFile={ downloadFile }
                        removeFile={ removeFile }
                        approveChangeRequest={ (...params) => submit(...params, 'Approve') }
                        declineChangeRequest={ (...params) => submit(...params, 'Decline') }
                    />
                    : null
            }
        </Content>
    );
};

/**
 * @param state
 * @returns {{loading: boolean}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default (connect(mapStateToProps)(ChangeRequestDetailsView));